import { signOut } from "firebase/auth";
import { auth } from "../firebase/firebase";


class useAuthUtilities {
  public isLogin(): boolean {
    const token = window.localStorage.getItem("token");
    return token ? true : false;
  }

  public async logout(): Promise<string> {
    try {
      await signOut(auth);
      window.localStorage.removeItem("user");
      window.localStorage.removeItem("token");
      return "You have been logged out"; 
    } catch (error: unknown) {

      if (error instanceof Error) {
        return "An error occurred while logging out: " + error.message;
      } else {
        return "An unknown error occurred while logging out."; 
      }
    }
  }
}

const AuthUtilities = new useAuthUtilities();
export default AuthUtilities;